import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const DocumentCategoryCard = ({ 
  category, 
  currentLanguage, 
  onGenerateClick 
}) => {
  const { t } = useLanguage();
  const getStatusColor = (percentage) => {
    if (percentage >= 80) return 'text-success bg-success/10';
    if (percentage >= 50) return 'text-warning bg-warning/10';
    return 'text-error bg-error/10';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-warm hover:shadow-warm-md transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-12 h-12 rounded-lg ${category?.bgColor} flex items-center justify-center`}>
            <Icon name={category?.icon} size={24} className={category?.color} />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">
              {category?.name?.[currentLanguage]}
            </h3>
            <p className="caption text-muted-foreground">
              {category?.description?.[currentLanguage]}
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            {t('documents.total')}
          </span>
          <span className="data-text font-medium text-foreground">
            {category?.total}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            {t('documents.generated')}
          </span>
          <span className="data-text font-medium text-success">
            {category?.generated}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            {t('documents.pending')}
          </span>
          <span className="data-text font-medium text-warning">
            {category?.pending}
          </span>
        </div>
      </div>
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="caption text-muted-foreground">
            {t('documents.progress')}
          </span>
          <span className={`caption font-medium ${getStatusColor(category?.completionRate)}`}>
            {category?.completionRate}%
          </span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full transition-all duration-500 ${
              category?.completionRate >= 80 ? 'bg-success' :
              category?.completionRate >= 50 ? 'bg-warning' : 'bg-error'
            }`}
            style={{ width: `${category?.completionRate}%` }}
          />
        </div>
      </div>
      <button
        onClick={() => onGenerateClick(category)}
        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-smooth"
      >
        <Icon name="FileText" size={18} />
        <span className="text-sm font-medium">
          {t('documents.generate')}
        </span>
      </button>
    </div>
  );
};

export default DocumentCategoryCard;